fccd-custom-select {
  hp6-select-decorator {
    margin-top: 0;
  }
  .inline {
    display: flex;
    align-items: center;
  }
  hp5-popover .tooltip-wrapper .tooltip-container {
    // set higher z-index so it is displayed over other field components when open.
    z-index: 8;
  }
}
